import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';

//import components
import PaginationTotal from './PaginationTotal.js';
import PaginationNextSmall from './PaginationNextSmall.js';
import PaginationPreviousSmall from './PaginationPreviousSmall.js';

const PaginationSmall = ({clang, totalPages, currentPage, currentPageState, setNextPage, setPreviousPage, setPageByNum, setCurrentPage, resetPageOnBlur}) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        setPageByNum(currentPageState);
    };

    return (
        <div className="pagination--small">
            {currentPage > 1 && currentPage <= totalPages && totalPages !== 1 &&
                <PaginationPreviousSmall setPreviousPage={setPreviousPage}/>}
            <div className="pagination__pages">
                <form className="pagination__form" onSubmit={(e) => handleSubmit(e)}>
                    <input className="pagination__input" type="number" min="1" max={totalPages}
                        value={currentPageState}
                        onBlur={(event) => resetPageOnBlur(event)}
                        onChange={(event) => setCurrentPage(event)}
                        disabled={totalPages === 1}/>
                    <button type="submit" className="hidden"></button>
                </form>
                <PaginationTotal
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setPageByNum={setPageByNum}/>
            </div>
            {currentPage >= 1 && currentPage < totalPages &&
                <PaginationNextSmall setNextPage={setNextPage}/>}
        </div>
    );
};

PaginationSmall.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationSmall);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationSmall.js